export default __webpack_public_path__ + "static/media/discord.fe11b3df.png";